import type { FC } from 'react';
import { cn } from '../lib/utils';
import { describeKeys } from './keyboard-shortcut';

interface ShortcutHintProps {
  /** Keys pressed together, as glyphs: `['⌘', '↵']`. */
  keys: readonly string[];
  className?: string;
}

/**
 * The 18px key chip on a button, menu row or toast (DESIGN.md §8.1). Says the
 * keys to a screen reader and shows the glyphs, so a button reads
 * "Validate, Command Enter".
 */
export const ShortcutHint: FC<ShortcutHintProps> = ({ keys, className }) => (
  <kbd
    className={cn(
      'pointer-events-none inline-flex h-[18px] min-w-[18px] shrink-0 items-center justify-center gap-0.5 rounded-[5px] border border-current/25 px-1 font-sans text-[10px] leading-none font-medium opacity-80 select-none',
      className
    )}
  >
    <span className="sr-only">, {describeKeys(keys)}</span>
    {/* Glyphs sit together (⌘↵); word labels need a gap (Ctrl ↵). */}
    <span aria-hidden="true">
      {keys.join(keys.every((key) => key.length === 1) ? '' : ' ')}
    </span>
  </kbd>
);
